import { Suspense, lazy } from "react";
import { Helmet } from "react-helmet-async";
import Hero from "../components/Hero";
import Features from "../components/Features";
import HowItWorks from "../components/HowItWorks";
import Downloads from "../components/Downloads";

const FAQ = lazy(() => import("../components/FAQ"));

function Home() {
  return (
    <>
      <Helmet>
        <title>Texmu – Smart content filtering for a distraction-free web</title>
        <meta
          name="description"
          content="Texmu blurs distracting words and topics across the web so you can focus on what matters."
        />
      </Helmet>
      <main id="main-content">
        <Hero />
        <Features />
        <HowItWorks />
        <Downloads />
        <Suspense fallback={null}>
          <FAQ />
        </Suspense>
      </main>
    </>
  );
}

export default Home;
